import * as React from "react";
import Box from "@mui/material/Box";
import Logo from "./Logo.js"; // Ensure this path is correct for your project
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import "./NavBackground.css";

export default function BoxSx() {
  // This helper function unchecks the box when a user clicks a link
  const handleClose = () => {
    const checkbox = document.querySelector('#menuToggle input[type="checkbox"]');
    if (checkbox) checkbox.checked = false;
  };

  return (
    <Box className="navbar">
      <Link href="./">
        <Logo />
      </Link>

      {/* Desktop Menu - Hidden on small screens via CSS */}
      <Box
        className="nav-menu"
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
        }}
      >
        <Button className="nav-item" variant="contained" href="/">
          Home
        </Button>
        <Button className="nav-item" variant="contained" href="/Location">
          Location
        </Button>
        <Button className="nav-item" variant="contained" href="/TypesOfTrees">
          Types of Trees
        </Button>
        <Button className="nav-item" variant="contained" href="/HowTheyGrow">
          How They Grow
        </Button>
        <Button className="nav-item" variant="contained" href="/Harvest">
          Harvest Time
        </Button>
        <Button className="nav-item" variant="contained" href="/Services">
          Services
        </Button>
      </Box>

      {/* Mobile Menu - Visible only on small screens via CSS */}
      <nav role="navigation">
        <div id="menuToggle">
          <input type="checkbox" />

          {/* These spans are the hamburger lines */}
          <span></span>
          <span></span>
          <span></span>

          <ul id="menu">
            <a href="/" onClick={handleClose}>
              <li>Home</li>
            </a>
            <a href="./Location" onClick={handleClose}>
              <li>Location</li>
            </a>
            <a href="./TypesOfTrees" onClick={handleClose}>
              <li>Types of Trees</li>
            </a>
            <a href="./howtheygrow" onClick={handleClose}>
              <li>How They Grow</li>
            </a>
            <a href="./harvest" onClick={handleClose}>
              <li>Harvest Time</li>
            </a>
            <a href="./services" onClick={handleClose}>
              <li>Services</li>
            </a>
          </ul>
        </div>
      </nav>
    </Box>
  );
}